// handle custom canonical paths
export const getCustomCanonical = (pathname) => {
  if (pathname === '/python-development-company/') {
    return '/technologies/python/'
  }

  return ''
}
